import { ModalCustom } from "components/ModalCustom";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Required } from "components/Required";
import { Controller, useForm } from "react-hook-form";
import temaPadrao from "_config/temas/estilo/base";
import { PrimaryButton } from "components/Button/style";
import { yupResolver } from "@hookform/resolvers/yup";
import { prosseguirManualmenteGerarProcesso } from "../../validate/validator";
import { ContainerForm } from "./style";
import { CustomInput } from "components/CustomInput";
import FileUpload from "components/UploadArquivos";
import { IGerarProcessoManualmente } from "../../Interfaces/IGerarProcessoManualmente";
import { useMaskInput } from "hooks/useMaskInput";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: (dados: IGerarProcessoManualmente) => void;
}

export function ModalProsseguirManualmenteGerarProcesso({
  show,
  handleClose,
  onSubmit,
}: Props) {
  const { mInputNum, mInputCoin,mInputDate,mInputDateTime } = useMaskInput();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(prosseguirManualmenteGerarProcesso),
  });

  useEffect(() => {
    reset({
      renavam: "",
      numeroProcesso: "",
      dataHoraProcesso: "",
      numeroGrd: "",
      capaRenavam: "",
      valor: 0,
      codigoDeBarras: "",
      dataVencimento: "",
    });
  }, [show]);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Prosseguir manualmente"
      centered
    >
      <form
        onSubmit={handleSubmit((dados: IGerarProcessoManualmente) => {
          onSubmit(dados);
        })}
      >
        <ContainerForm>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Renavam <Required />
                </Form.Label>
                <Controller
                  name="renavam"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      mensagemErro={errors.renavam?.message}
                      type="text"
                      placeholder="Digite o renavam"
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(value) => {
                        onChange(mInputNum(value));
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Número do processo <Required />
                </Form.Label>
                <Controller
                  name="numeroProcesso"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      mensagemErro={errors.numeroProcesso?.message}
                      type="text"
                      placeholder="Digite o número"
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(value) => {
                        onChange(mInputNum(value));
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Código de barras <Required />
                </Form.Label>
                <Controller
                  name="codigoDeBarras"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      mensagemErro={errors.codigoDeBarras?.message}
                      type="text"
                      placeholder="Digite o código de barras"
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(value) => {
                        onChange(value);
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Valor <Required />
                </Form.Label>
                <Controller
                  name="valor"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      mensagemErro={errors.valor?.message}
                      type="text"
                      placeholder="Digite o valor"
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(e: any) => {
                        onChange(
                          mInputCoin({
                            ...e,
                            target: {
                              ...e.target,
                              value: e.target.value.replace(/[^0-9.]/g, ""),
                            },
                          })
                        );
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Data/hora do processo <Required />
                </Form.Label>
                <Controller
                  name="dataHoraProcesso"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      mensagemErro={errors.dataHoraProcesso?.message}
                      type="text"
                      placeholder="DD/MM/AAAA 00:00:00"
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(value) => {
                        onChange(mInputDateTime(value));
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Data de vencimento <Required />
                </Form.Label>
                <Controller
                  name="dataVencimento"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      mensagemErro={errors.dataVencimento?.message}
                      type="text"
                      placeholder="DD/MM/AAAA"
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(value) => {
                        onChange(mInputDate(value));
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Número da GRD <Required />
                </Form.Label>
                <Controller
                  name="numeroGrd"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      type="text"
                      placeholder="Informe o número da GRD"
                      mensagemErro={errors.numeroGrd?.message}
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(value) => {
                        onChange(mInputNum(value));
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Capa Renavam
                </Form.Label>
                <Controller
                  name="capaRenavam"
                  control={control}
                  render={({ field: { onChange } }) => (
                    <FileUpload
                      onFileUpload={(file) => {
                        onChange(file);
                      }}
                      mensagemErro={errors.capaRenavam?.message}
                      inputAccept=".pdf"
                      comMaxWidth={false}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </ContainerForm>
        <div className="d-flex justify-content-between gap-4 mt-4">
          <PrimaryButton
            style={{ width: "14rem" }}
            outline
            variante="primary"
            onClick={handleClose}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton style={{ width: "14rem" }} type="submit">
            Prosseguir
          </PrimaryButton>
        </div>
      </form>
    </ModalCustom>
  );
}
